export default { sha: '02bea0e88b88ca854b2e66fe26740e09805142ff', buildNumber: 'undefined' }
